// Static, per-deployment fields for the Renault Group "GTM Guidelines Wizard"
// dataLayer convention. Set per brand/hostname in public/config.js - a brand
// that doesn't configure one of these just never pushes that field.
const getWizardStaticParams = () => {
    const ENV = window.ENV[window.location.hostname] || window.ENV.default;
    return {
        brand: ENV.GA_BRAND,
        countryCode: ENV.COUNTRY_CODE,
        googleAccount: ENV.GOOGLE_ACCOUNT,
        businessType: ENV.BUSINESS_TYPE,
    };
};

export default getWizardStaticParams;
